// Bearer (JWT) refresh transport.
//
// The backend refresh is an HttpOnly `refresh_token` cookie + CSRF
// (CustomTokenRefreshSerializer): the call carries no Authorization header,
// instead relying on the cookie (`credentials: "include"`) and echoing the
// `csrftoken` cookie back via `X-CSRFToken`. The response returns a fresh
// `{ access }`.
//
// Wired into the 401→refresh path for switched (Bearer) sessions by
// `utils/services.util.ts` (single-flight `refreshBearerOnce`). `baseUrl` is
// passed in (rather than read from `import.meta.env`) so this module stays
// unit-testable under ts-jest.
import { getCsrfToken } from "utils/auth-header.util";

// Backend route: CookieTokenRefreshView (suno-backend accounts/views/token.py).
// `/auth/...` (not `/api/auth/...`) because `VITE_SUNO_API` already ends in `/api`.
const REFRESH_PATH = "/auth/jwt/refresh/";

export type RefreshResult = {
  access: string;
} | null;

export const refreshBearerToken = async (
  baseUrl: string
): Promise<RefreshResult> => {
  try {
    const response = await fetch(`${baseUrl}${REFRESH_PATH}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": getCsrfToken()
      }
    });
    if (!response.ok) return null;
    const data = await response.json();
    return data?.access ? { access: data.access } : null;
  } catch {
    return null;
  }
};
